import React from "react";
import "./PGAModelBuilderSlateSelect.css";
import Select from "react-select";
import { graphql, useLazyLoadQuery } from "react-relay";

const GET_SLATES = graphql`
  query PGAModelBuilderSlateSelectQuery {
    modelSlates {
      id
      gameType {
        name
      }
      suffix
      slatecompetitionSet {
        edges {
          node {
            id
            competition {
              name
            }
          }
        }
      }
    }
  }
`;

export default function PGAModelBuilderSlateSelect(props) {
  const data = useLazyLoadQuery(GET_SLATES);

  return (
    <Select
      id="slate-select"
      options={data.modelSlates.map((slate) => {
        const tournamentName =
          slate.slatecompetitionSet.edges[0].node.competition.name;

        return {
          label: `${slate.gameType.name}${slate.suffix} - ${tournamentName}`,
          value: slate.id,
        };
      })}
      {...props}
    />
  );
}
